import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import theme from 'styled-theming';

import * as Colors from '../../attrs/colors';

const ContainerLayout = theme('layout', {
  contain: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${rgba(Colors.WHITE, 0.8)};
  `,
});

export const Container = styled.div`
  padding: 1rem;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  ${ContainerLayout};
`;

export const SvgContainer = styled.svg`
  animation: rotate 2s linear infinite;
  width: 30px;
  height: 30px;

  & .path {
    stroke: ${Colors.BLACK};
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;
